import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    cardContainer: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    cardContent: {
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
    },
    label: {
        fontSize: '0.9rem',
        color: '#9D9D9D',
        lineHeight: '14,1px',
        textAlign: 'justify',
        marginRight: '3px'
    },
    qrcode: {
        display: 'flex',
        flexDirection: "column",
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(1)
    },
    qrText: {
        textAlign: 'center',
    },
    buttonRemover: {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
        '& svg': {
            fill: theme.palette.error.main
        }
    },
    htmlContainer: {
        border: `1px solid ${theme.palette.secondary.light}`,
        height: '100%',
        borderRadius: 7,
        padding: 5,
        overflow: 'hidden',
        position: 'relative',
        '& .divImgFundo': {
            position: 'absolute'
        },
        [theme.breakpoints.down('sm')]: {
            minHeight: 400
        },
        minHeight: 600,
    },
}));